"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  AFTER_SERVICE: 'afterService',
  BANNED: 'banned',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  INCOMING: 'incoming',
  OFFLINE: 'offline',
  ONLINE: 'online',
  OUTGOING: 'outgoing',
  READY: 'ready'
};